import { useTranslation } from 'react-i18next';

import { resources } from '../../../resources/resources';
import ImportTimesheetFileForm from './Components/ImportTimesheetForm';

export default function ImportTimesheetPage() {
  const { t: translate } = useTranslation();
  return (
    <div className="panel padding-xl uploads-panel">
      <h1>{translate(resources.admin.importTimesheets.title)}</h1>
      <ImportTimesheetFileForm />
    </div>
  );
}
